export default function getCrumbs(city, tag, searchTerm) {
  const crumbs = [{ text: 'Food Trucks', url: `/food-trucks/` }]

  if (city.region) {
    crumbs.push({
      text: city.region.name,
      url: `/food-trucks/${city.region.url_slug}/`,
    })
  }

  if (city.county) {
    crumbs.push({
      text: city.county.name,
      url: `/food-trucks/${city.county.url_slug}/`,
    })
  }

  if (city.city) {
    crumbs.push({
      text: city.city.name,
      url: `/food-trucks/${city.city.url_slug}/`,
    })
  }

  crumbs.push({
    text: city.name,
    url: searchTerm || tag ? `/food-trucks/${city.url_slug}/` : null,
  })

  if (tag) {
    crumbs.push({
      text: tag.name,
      url: searchTerm ? `/food-trucks/${city.url_slug}/${tag.slug}/` : null,
    })
  }

  if (searchTerm) {
    crumbs.push({
      text: `Search: ${searchTerm}`,
    })
  }

  return crumbs
}
